import React from "react";
import ReactDOM from "react-dom/client";
import { Router } from "./Router.tsx";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(<Router />);
